"use client";
import React, { useState } from "react";

import StyledButton, { StyledButtonProps } from "@stadium/ui/src/components/button/styled-button";

import defaultStyles from "./main.module.scss";

type BannerColors = "red" | "green" | "blue" | "lavender" | "lightYellow" | "grey";

type AnnouncementBarProps = {
  children: React.ReactNode;
  styles?: ModularStyles;
  color?: BannerColors;
  showCross?: boolean;
  className?: string;
  iconCloseClass?: string;
  handleOnCloseClick?: StyledButtonProps["onClick"];
};

const AnnouncementBar = ({
  children,
  styles = defaultStyles,
  color = "green",
  showCross = true,
  className = "",
  iconCloseClass = "",
  handleOnCloseClick = null,
}: AnnouncementBarProps) => {
  const [isOpen, setIsOpen] = useState(true);

  const COLOR_STYLE: { [color in BannerColors]: string } = {
    red: styles.bannerRed,
    green: styles.bannerGreen,
    blue: styles.bannerBlue,
    lavender: styles.bannerLavender,
    lightYellow: styles.bannerLightYellow,
    grey: styles.bannerGrey,
  };

  return (
    isOpen && (
      <div className={`${styles.bannerContainer} ${COLOR_STYLE[color]} ${className}`} tabIndex={0}>
        <div className={styles.bannerContent}>{children}</div>
        {showCross && (
          <StyledButton
            styleType="link"
            onClick={(e) => {
              handleOnCloseClick?.(e);
              setIsOpen(false);
            }}
            className={`${styles.closeIcon} ${iconCloseClass}`}
            title="Close announcement bar"
          />
        )}
      </div>
    )
  );
};

export default AnnouncementBar;
